import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
  useParams,
} from "./../../common/helper/common-imports.component.js";
import {
  getConditionalRowStyles,
  customExpandableIcon,
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import CloseIcon from "@mui/icons-material/HighlightOff";
import paymentMethodsService from "../../../services/payment-methods.service.js";
import {
  initialFormData,
  initialErrors,
  fieldValidation,
} from "../../common/helper/form-constants.js";
import Confirmation from "../../common/modals/confirmation.component.js";
import MUIButtonUploadImage from "../../common/miui-component/muibtn1.jsx";
import { Switch } from "@mui/material";
import { useMemo, useRef } from "react";
import { ConfigService } from "../../../services/index.js";
import SelectSearch from "react-select-search";

const paymentMethods = () => {
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [paymentList, setPaymentList] = useState([]);
  const [paymentType, setPaymentType] = useState("phonePe");
  const [paymentTypeWallet, setPaymentTypeWallet] = useState("paytm");
  const [formData, setFormData] = useState({ phoneNumber: "" });
  const userData = useSelector((state) => state.authReducer);
  const isAdmin = userData?.user?.data?.role?.role_code === "ADMIN";
  const isDAdmin = userData?.user?.data?.role?.role_code === "DADMIN";
  const [formDataUPI, setFormDataUPI] = useState({
    phoneNumber: "",
    upiID: "",
  });
  const selectRef = useRef({});
  const [distributorId, setDistributor] = useState({ distributor_id: "" });
  const [agentId, setAgentsId] = useState({ agent_id: "" });
  const [fileInfo, setFileInfo] = useState(null);
  const [errors, setErrors] = useState({ ...initialErrors });
  const [hideWalletPayment, sethideWalletPayment] = useState();
  const [hideUpiPayment, sethideUpiPayment] = useState();
  const [modalShow, setModalShow] = React.useState(false);
  const [row, setRow] = useState({});
  const [editW, setEditW] = useState(false);
  const [editU, setEditU] = useState(false);
  const [imagePrefix, setImagePrefix] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [toggleStatus, setToggleStatus] = useState(false);
  const [nickName, setNickName] = useState("");
  const [distributors, setDistributors] = useState();
  const [agents, setAgents] = useState();

  const listPayments = () => {
    setLoading(true);
    paymentMethodsService
      .getPaymentMethods(agentId.agent_id)
      .then((response) => {
        setPaymentList({
          wallet: response.data.data.wallet,
          upi: response.data.data.upi,
          qr: response.data.data.qr,
        });
        // console.log(response.data.data.qr)
        setLoading(false);
        if (response.data.data.qr.length > 0) {
          const prefix = `data:};base64,`;
          const imageUrlWithPrefix = prefix + response.data.data.qr[0].qr_image;
          setImagePrefix(imageUrlWithPrefix);
          setImageUrl("");
        }
        //setImageUrl(response.data.data.qr[0].qr_image)
      })
      .catch((error) => {
        // console.log(error)
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };
  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
  };
  const getAgentsByDistributor = (e=null) => {
    ConfigService.getAgentDropDownByDistributorId(e)
      .then((response) => {
        const agents = response.data.data;
        const arr = [{ name: "All Agents", value: "" }];
        for (var i = 0; i < agents.length; i++) {
          arr.push({
            name: agents[i].value,
            value: agents[i].key,
          });
        }
        setAgents(arr);
      })
      .catch((error) => {});
  };
  const getAgents = (e=null) => {
    ConfigService.getAgentsDropDown(e)
      .then((response) => {
        const agents = response.data.data;
        const arr = [{ name: "All Agents", value: "" }];
        for (var i = 0; i < agents.length; i++) {
          arr.push({
            name: agents[i].value,
            value: agents[i].key,
          });
        }
        setAgents(arr);
      })
      .catch((error) => {});
  };

  const getDistributors = () => {
    ConfigService.getDistributorDropDown()
      .then((response) => {
        const agents = response.data.data;
        const arr = [{ name: "All Distributors", value: "" }];
        for (var i = 0; i < agents.length; i++) {
          arr.push({
            name: agents[i].value,
            value: agents[i].key,
          });
        }
        setDistributors(arr);
      })
      .catch((error) => {});
  };


  const changeStatus = (row) => {
    setModalShow(true);
    setRow({
      id: row.id,
      status: row.status_id,
      modalId: "statusChangePayment",
    });
  };


  const checkStatus = (name, row) => {
    console.log(name, row);
    if (name == "A") {
      return (
        <label
          className="switch"
          onClick={(event) => {
            event.preventDefault(); // Prevent the default action
            changeStatus(row); // Call your changeStatus function
          }}
        >
          <input type="checkbox" className="switch-input" checked />
          <span className="switch-label" data-on="Active" data-off="Deactive" />
          <span className="switch-handle" />
        </label>
      );
    } else {
      return (
        <div data-tag="allowRowEvents">
          <label
            className="switch"
            onClick={(event) => {
              event.preventDefault(); // Prevent the default action
              changeStatus(row); // Call your changeStatus function
            }}
          >
            <input type="checkbox" className="switch-input" />
            <span
              className="switch-label"
              data-on="Active"
              data-off="Deactive"
            />
            <span className="switch-handle" />
          </label>
        </div>
      );
    }
  };

  const columns = useMemo(
    () => [
      {
        name: "Nick Name",
        selector: (row) => <span>{row?.nick_name}</span>,
        sortable: true,
      },
      {
        name: "Method Type",
        selector: (row) => <span>{row?.method_type_code}</span>,
        sortable: true,
      },
      {
        name: "created Date",
        selector: (row) => <span>{row.created_on}</span>,
        sortable: true,
      },
      {
        name: "Status",
        selector: (row) => checkStatus(row.status_id, row),
        sortable: true,
      },
      {
        name: "QR Image",
        // sortable: true,
        cell: (row) => (
          <img
            src={row?.qr_image_url}
            alt="Uploaded QR Code"
            className="image-preview-payment"
            style={{
              display: "block",
              width: "60px",
              height: "40px",
              border: "1px solid gray",
              borderRadius: "10px",
            }}
          />
        ),
      },
      // {
      //   name: "Updated At",
      //   selector: (row) => row.updated_on,
      //   sortable: true,
      // },
      {
        name: "Actions",
        button: true,
        cell: (row) => (
          <>
            {/* <a className="fview tooltip" style={{'cursor':'pointer'}}  onClick={() => ViewMerchant( row.merchant_detail.merchant_id)}>
         <i className="fa fa-eye"/>
          <span className="tooltiptext">View</span>
        </a> */}

            {/* <a
            className="fedit tooltip"
            href="#"
            onClick={() => editPayment(row)}
          >
            <i className="fa fa-edit" style={{ color: "black" }}></i>
            <span className="tooltiptext">Edit</span>
          </a> */}
            <a className="ftrash tooltip" href="#">
              <i
                className="fa fa-trash"
                style={{ color: "black" }}
                onClick={() => deletePayment(row)}
              ></i>
              <span className="tooltiptext">Delete</span>
            </a>
            {/* <a className="fell tooltip" href="#">
            <i
              className="fa fa-ellipsis-v"
              aria-hidden="true"
              style={{ color: "black" }}
            ></i>
            <span className="tooltiptext">More</span>
          </a> */}
          </>
        ),
      },
    ],
    [paymentList]
  );

 

  const deletePayment = (row) => {
    setModalShow(true);
    setRow({
      id: row.id,
      status: row.status,
      modalId: "deletePayment",
    });
  };

 
 

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  useEffect(() => {
if(isDAdmin || isAdmin) {
    } else {
    listPayments();

    }    
    document.body.style.backgroundColor = "#f0f6fa";

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleFileChange = () => {
    const file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    if (!file.type || !file.type.startsWith("image/")) {
      toast.error("Please select an image file.");
      return;
    }

    if (file && file.size <= maxSize) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageUrl(reader.result);
      };

      setFileInfo(file);
      reader.readAsDataURL(file);
    } else {
      setImageUrl("");
      toast.error("File size exceeds 2 MB. Please select a smaller file.");
    }
  };

  const uploadQR = () => {

    if (!imageUrl) {
      toast.error("Please select a QR code image.");
      return;
    }
    const base64Data = imageUrl.split(",")[1];
    // console.log(base64Data,imageUrl)
    setLoading(true);
    const data = {
      qr_image: base64Data,
      method_type_code: "QR",
      nick_name: nickName,
      status_id: toggleStatus ? "A" : "S",
      qr_image_file_name: fileInfo?.name,
    };
    paymentMethodsService
      .addPaymentMethod(data, agentId.agent_id)
      .then((response) => {
        toast.success("QR added successfully.");
        listPayments();
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      })
      .finally(() => {
        setImageUrl("");
        setNickName("");
        setToggleStatus(false);
      });
  };

  const handleNickName = ({ target: { name, value } }) => {
    setNickName(value);
  };

  const toggleBtnUploadStatus = () => {
    setToggleStatus((prev) => !prev);
  };

  const removeUploadImage = () => {
    console.log("..");
    setFileInfo(null);
    setImageUrl("");
    setNickName("");
    setToggleStatus(false);
  };
  const handleChangeSearchDistributor = (e) => {
    setDistributor((prevData) => ({ ...prevData, ["distributor_id"]: e }));
    getAgentsByDistributor(e)
  };
  const setSelectRef = (name, select) => {
    if (select) {
      if (selectRef.current) {
        selectRef.current[name] = select.querySelector("input");
      }
    }
  };
  const handleChangeSearch = (e) => {
    setAgentsId((prevData) => ({ ...prevData, ["agent_id"]: e }));
    // getAgents(e);
  };
  const handleIconClick = (name) => {
    if (selectRef.current) {
      if (selectRef.current[name]) {
        selectRef.current[name].focus(); // Focus on the specific dropdown input
      }
    }
  };
  useEffect(() => {
    if(isDAdmin) {
      getAgents();
    } 
    if(isAdmin) {
      getDistributors();

    }
  }, []);
    useEffect(() => {
      console.log(agentId)
    if(agentId.agent_id) {
      listPayments();
    }
  },[agentId])
  console.log(distributorId, agentId);
  useEffect(() => {
    if (paymentList.qr?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      console.log(childElement);
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("odd-transaction-table");
        } else {
          childElement[i].classList.add("even-transaction-table");
        }
      }
    }
  }, [paymentList]);

  // useEffect(() => {
  //   listPayments();
  // },[agentId])
  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="d-flex flex-column flex-md-row flex-wrap justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Payment Methods
          </h4>
       
          <div>
            <div className="d-flex flex-wrap gap-3  my-3 my-md-0">
              <div className="d-none d-md-block">
                {imageUrl ? (
                  <div className="position-absolute" style={{ right: "390px" }}>
                    <img
                      src={imageUrl}
                      alt="Uploaded QR Code"
                      className="image-preview image-preview-payment-card"
                      style={{
                        display: "block",
                        width: "60px",
                        height: "40px",
                        border: "1px solid gray",
                        borderRadius: "10px",
                      }}
                    />
                    <span
                      onClick={removeUploadImage}
                      className="position-relative"
                      style={{ bottom: "50px", left: "75%", cursor: "pointer" }}
                    >
                      <CloseIcon sx={{ fontSize: "25px" }} />
                    </span>
                  </div>
                ) : (
                  <MUIButtonUploadImage
                    // btnOnClick={() => setIsOpenDrawer(true)}
                    // btnOnClick={uploadQR}
                    // btnLabel="Upload"
                    disabledbtn={imageUrl ? true : false}
                    btnStyle={{
                      backgroundColor: "#ffffff",
                      color: "black",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "rgb(117 121 124 / 82%)",
                      },
                    }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      id="payment_qr_code"
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="payment_qr_code"
                      className="image-button tooltip"
                    >
                      <i
                        className="fa fa-cloud-upload"
                        style={{ fontSize: "25px" }}
                      />
                      {/* <span className="tooltiptext newtooltip">Select the QR code you want to upload</span> */}
                    </label>
                    {/* <FilterListIcon sx={{ fontSize: "25px", marginLeft: "6px" }} />{" "} */}
                  </MUIButtonUploadImage>
                )}
              </div>

              {imageUrl && (
                <div className="d-flex align-items-center justify-content-center">
                  <div
                    className="form-group frm mb-0"
                    style={{ textAlign: "left" }}
                  >
                    <input
                      type="text"
                      value={nickName}
                      onChange={handleNickName}
                      className="form-control nickname "
                      placeholder="Enter Nick Name"
                      name="f_name"
                      style={{ borderRadius: "10px", padding: "20px" }}
                    />
                  </div>
                  <div>
                    {/* <label
                              className="mb-0 text-color-theme"
                              style={{ fontSize: "15px", fontWeight: "bolder" }}
                            >
                              Active
                            </label> */}
                    <Switch
                      checked={toggleStatus}
                      onChange={toggleBtnUploadStatus}
                    />
                    {/* <label
                              className="mb-0 text-color-theme"
                              style={{ fontSize: "15px", fontWeight: "bolder" }}
                            >
                              Amount
                            </label> */}
                  </div>
                  <MUIButtonUploadImage
                    // btnOnClick={() => setIsOpenDrawer(true)}
                    btnOnClick={uploadQR}
                    btnLabel="Upload"
                    btnStyle={{
                      backgroundColor: "#ffffff",
                      color: "black",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "rgb(117 121 124 / 82%)",
                      },
                    }}
                  >
                    {/* <FilterListIcon sx={{ fontSize: "25px", marginLeft: "6px" }} />{" "} */}
                  </MUIButtonUploadImage>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container-fluid" style={{ backgroundColor: "white" }}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active"
                id="nav-contact-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="true"
                onclick="myFunctiosn()"
                tabIndex={-1}
              >
                QR Code
              </button>

              {/* <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="true" onclick="myFunction()">UPI</button>
              <button className="nav-link tbbtn active">QR Code</button> */}
            </div>
          </nav>
          <div className="d-flex justify-content-between gap-4">
          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
          <div className="d-flex gap-4">
         { isAdmin  &&  (<div className="form-group frm" style={{ textAlign: "left" }}>
              <label>Select Distributor</label>
              <SelectSearch
                search={true}
                options={distributors}
                onChange={handleChangeSearchDistributor}
                ref={(select) => setSelectRef("customer_id_2", select)}
                value={distributorId.distributor_id}
                name="distributor_id"
                placeholder="All Distributors"
              />
              <span
                class="fa fa-angle-down errspan"
                style={{ cursor: "pointer" }}
                onClick={() => handleIconClick("customer_id_2")}
              ></span>
            </div>)}
            {(isDAdmin || isAdmin) && (
                <div className="form-group frm" style={{ textAlign: "left" }}>
                <label>Select Agent</label>
                <SelectSearch
                  value={agentId.agent_id}
                  search={true}
                  options={agents}
                  onChange={handleChangeSearch}
                  ref={(select) => setSelectRef("customer_id_3", select)}
                  name="agent_id"
                  placeholder="All Agents"
                />
                <span
                  class="fa fa-angle-down errspan"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleIconClick("customer_id_3")}
                ></span>
              </div>
            )}
          
          </div>
          </div>

          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <div
              className="tab-pane fade show active"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact-tab"
              style={{ marginTop: "15px" }}
            >
              <div className="panel panel-default">
                <div
                  id="examplemgmwallet_wrapper"
                  className="dataTables_wrapper dt-jqueryui no-footer"
                >
                  <div className="payment-table">
                    <DataTable
                      key={0}
                      columns={columns}
                      data={paymentList.qr}
                      pagination
                      customStyles={customDataTableStyles}
                      paginationComponentOptions={paginationComponentOptions}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          show={modalShow}
          onHide={() => setModalShow(false)}
          onSave={() => updateStatus(false)}
          status={row.status}
          modalId={row.modalId}
        ></Confirmation>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(paymentMethods));
